import { createFileRoute, Outlet } from '@tanstack/react-router';
import { NoAccess } from '@/components/custom/no-access';
import { useMe } from '@/lib/me';

// Layout for /users/* — list + detail + edit nest under a common parent.
// Gates every child on `user.view`.
export const Route = createFileRoute('/_authenticated/users')({
  component: UsersLayout,
});

function UsersLayout() {
  const { permissions, loading } = useMe();
  if (!loading && !permissions.has('user.view')) {
    return <NoAccess permission="user.view" resource="Employees" />;
  }
  return <Outlet />;
}
